"use strict";

var _slicedToArray = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Utils_1 = require("./Utils");
var AceAlignmentMode_1 = require("./AceAlignmentMode");
var Residues_1 = require("./Residues");
var AlignmentSorter_1 = require("./AlignmentSorter");
var MolecularStyles_1 = require("./MolecularStyles");
/**
 * Alignment
 * This class represents a multiple sequence alignment. During initialization,
 * positional statistics are generated about the alignment and a consensus
 * sequence is determined.
 *
 * The class should generally be instantiated from subclasses (e.g., FastaAlignemtn)
 * using static methods, e.g.,
 *     FastaAlignment.fromFileContents
 *     StockholmAlignment.fromFileContents
 */
var Alignment = /*#__PURE__*/function () {
  /**
   * Create a new Alignment object. The default query sequence will
   * be set to the first sequence in sequences. This can be changed
   * by calling setQuerySequence() after creation
   * @param sequences
   */
  function Alignment(name, sequencesAsInput) {
    _classCallCheck(this, Alignment);
    this.positionalLetterCounts = new Map();
    this.globalAlphaLetterCounts = {};
    this.uuid = Utils_1.generateUUIDv4();
    this.name = name;
    this.sequences = new Map();
    this.sequences.set(AlignmentSorter_1.SequenceSorter.INPUT, sequencesAsInput);
    this.querySequence = sequencesAsInput[0];
    this.predictedNT = true;
    //
    //generate statistics
    //
    var start = new Date();
    var allLettersInAlignment = {}; //all letters in the alignment
    // aggregate stats for each position and globally including
    // the number of time each amino acid occurs
    // ** this loop takes the bulk of the initialization time
    for (var sequenceIdx = 0; sequenceIdx < sequencesAsInput.length; sequenceIdx++) {
      var seq = sequencesAsInput[sequenceIdx].sequence;
      for (var positionIdx = 0; positionIdx < seq.length; positionIdx++) {
        var letter = seq[positionIdx];
        var letterIsAlpha = letter.match(/[a-z]/i) ? true : false;
        if (letterIsAlpha && this.predictedNT && Residues_1.Nucleotide.fromSingleLetterCode(letter) === Residues_1.Nucleotide.UNKNOWN) {
          this.predictedNT = false;
        }
        var position = positionIdx; // zero based
        allLettersInAlignment[letter] = 1;
        var letterCounts = this.positionalLetterCounts.get(position);
        if (!letterCounts) {
          letterCounts = {};
          this.positionalLetterCounts.set(position, letterCounts);
        }
        if (letter in letterCounts === false) {
          letterCounts[letter] = 0;
        }
        letterCounts[letter] += 1;
        if (letterIsAlpha) {
          if (letter in this.globalAlphaLetterCounts === false) {
            this.globalAlphaLetterCounts[letter] = 0;
          }
          this.globalAlphaLetterCounts[letter] += 1;
        }
      }
    }
    //get a list of all the upper letters found in the alignment
    this.allUpperAlphaLettersInAlignmentSorted = Object.keys(allLettersInAlignment).sort().reduce(function (arr, value) {
      if (value.match(/[A-Z]/)) {
        // only keep letters
        arr.push(value);
      }
      return arr;
    }, []);
    //determine consensus sequence
    var consensusStats = Array.from(this.positionalLetterCounts).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        position = _ref2[0],
        letterCounts = _ref2[1];
      var topLetter = Object.keys(letterCounts).reduce(function (a, b) {
        var aIsLetter = a.match(/[a-z]/i);
        var bIsLetter = b.match(/[a-z]/i);
        if (aIsLetter && !bIsLetter) {
          return a;
        }
        if (bIsLetter && !aIsLetter) {
          return b;
        }
        return letterCounts[a] > letterCounts[b] ? a : b;
      });
      return {
        position: position,
        letter: topLetter,
        occurrences: letterCounts[topLetter]
      };
    });
    this.consensus = {
      sequence: {
        id: "consensus",
        sequence: consensusStats.map(function (s) {
          return s.letter;
        }).join("")
      },
      statistics: consensusStats
    };
    console.log("done parsing alignment. took " + (new Date().getTime() - start.getTime()) + "ms");
  }
  /**
   * Normalize all values in an object that contains all counts such that
   * the sum of those counts equals 1.
   * @param letterCounts an object that contains the same keys, but whose
   *                     values now sum to 1.
   * @param validLetters if provided, returned object will only contain letters
   *                     that are in this array.
   */
  _createClass(Alignment, [{
    key: "getPredictedType",
    /**
     * Is this alignment predicted to be nucleotides?
     * @returns true if it is predicted to be nucleotide sequences.
     */
    value: function getPredictedType() {
      return this.predictedNT ? MolecularStyles_1.AlignmentTypes.NUCLEOTIDE : MolecularStyles_1.AlignmentTypes.AMINOACID;
    }
    /**
     * Returns a default nucleotide or amino acid style for this alignment,
     * predicted from the sequence itself.
     */
  }, {
    key: "getDefaultStyle",
    value: function getDefaultStyle() {
      return this.predictedNT ? new MolecularStyles_1.NucleotideAlignmentStyle() : new MolecularStyles_1.AminoAcidAlignmentStyle();
    }
    /**
     * Get a unique uuid for this alignment.
     * @returns a uuid string for this alignment
     */
  }, {
    key: "getUUID",
    value: function getUUID() {
      return this.uuid;
    }
    /**
     * Get the name of this alignment
     * @returns a name for the alignment - usually the filename
     */
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }
    /**
     * Get an ace editor mode for this alignemnt. If one doesn't exist
     * then it will be defined.
     * @returns the ace editor mode for this alignment
     */
  }, {
    key: "getAceEditorMode",
    value: function getAceEditorMode() {
      if (!this.aceEditorMode) {
        this.aceEditorMode = "ace/mode/" + this.uuid;
        AceAlignmentMode_1.defineNewAlignmentMode(this.aceEditorMode, this);
      }
      return this.aceEditorMode;
    }
    /**
     * Get the consensus sequence
     * @returns a position ordered array of objects that contain each letter, its number of
     *          occurrences, and the actual position number
     */
  }, {
    key: "getConsensus",
    value: function getConsensus() {
      return this.consensus;
    }
    /**
     * Get the number of gaps at each position
     * @returns an array of gap counts, ordered by position
     */
  }, {
    key: "getGapsPerColumn",
    value: function getGapsPerColumn() {
      return Array.from(this.positionalLetterCounts).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          position = _ref4[0],
          letterCounts = _ref4[1];
        return !isNaN(letterCounts["-"]) ? letterCounts["-"] : 0;
      });
    }
    /**
     * Get the number of gaps at a specific position
     * @returns the gap counts at the specified position
     */
  }, {
    key: "getGapCountAtColumn",
    value: function getGapCountAtColumn(position) {
      var letterCounts = this.positionalLetterCounts.get(position);
      if (!letterCounts || !letterCounts["-"]) {
        return 0;
      }
      return letterCounts["-"];
    }
    /**
     * Get the total number of times each letter appears in the alignment.
     * @param normalize if true, will normalize the returned array such that
     *                  it sums to 1.
     * @param validLetters if provided, only those letters will be included
     *                     in the resulting counts
     */
  }, {
    key: "getGlobalAlphaLetterCounts",
    value: function getGlobalAlphaLetterCounts(normalize, validLetters) {
      var _this = this;
      if (normalize) {
        return Alignment.normalizeLetterCounts(this.globalAlphaLetterCounts, validLetters);
      }
      return !validLetters ? this.globalAlphaLetterCounts : Object.keys(this.globalAlphaLetterCounts).reduce(function (acc, letter) {
        //don't normalize, but remove invalid letters
        if (validLetters.includes(letter)) {
          acc[letter] = _this.globalAlphaLetterCounts[letter];
        }
        return acc;
      }, {});
    }
    /**
     * Get the length of the longest sequence
     * @returns the length of the largest sequence in this alignment
     */
  }, {
    key: "getMaxSequenceLength",
    value: function getMaxSequenceLength() {
      return this.getSequences().reduce(function (acc, seq) {
        if (seq.sequence.length > acc) {
          acc = seq.sequence.length;
        }
        return acc;
      }, -1);
    }
    /**
     * Get the frequencies of all letters in this alignment for each position.
     * @param normalize if true, will normalize the returned letter counts for each
     *                  position such that each sums to 1.
     * @param validLetters if provided, only those letters will be included
     *                     in the resulting counts
     * @returns a Map whose keys are position (ordered) and values are a dictionary
     *          with [key = letter (e.g., amino acid code)] and [value = # occurrences].
     * TODO: Test parameter use cases.
     */
  }, {
    key: "getPositionalLetterCounts",
    value: function getPositionalLetterCounts(normalize, validLetters) {
      if (normalize || validLetters) {
        return Array.from(this.positionalLetterCounts).reduce(function (acc, _ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            position = _ref6[0],
            letterCounts = _ref6[1];
          acc.set(position, normalize ? Alignment.normalizeLetterCounts(letterCounts, validLetters) // normalize + remove invalid letters
          : Object.keys(letterCounts).reduce(function (acc2, letter) {
            //don't normalize, but remove invalid letters
            if (validLetters.includes(letter)) {
              acc2[letter] = letterCounts[letter];
            }
            return acc2;
          }, {}));
          return acc;
        }, new Map());
      }
      return this.positionalLetterCounts;
    }
    /**
     * Get all the sequences in this alignment - ordered as they were input
     * @param sortBy specifies the order of the returned sequences. If it isn't
     *               provided, returns the sequences as they were input to create
     *               the Alignment object, e.g., usually fasta order.
     * @param forceReSort if provided, sequences are forced to be re-sorted (rather
     *                    than possibly cached)
     * @returns all sequences in this alignment
     */
  }, {
    key: "getSequences",
    value: function getSequences(sortBy, forceReSort) {
      sortBy = sortBy ? sortBy : AlignmentSorter_1.SequenceSorter.INPUT;
      forceReSort = forceReSort ? forceReSort : false;
      if (sortBy !== AlignmentSorter_1.SequenceSorter.INPUT && (!this.sequences.has(sortBy) || forceReSort)) {
        //cache not yet populated for this sort option
        this.sequences.set(sortBy, sortBy.sortFn(this.sequences.get(AlignmentSorter_1.SequenceSorter.INPUT), this));
      }
      return this.sequences.get(sortBy);
    }
    /**
     * Get a sorted list of all of the upper case letters in the alignment.
     * @returns a list of all letters in the alignment sorted alphabetically.
     */
  }, {
    key: "getAllUpperAlphaLettersInAlignmentSorted",
    value: function getAllUpperAlphaLettersInAlignmentSorted() {
      return this.allUpperAlphaLettersInAlignmentSorted;
    }
    /**
     * Get all the first sequence in the alignment, aka, target / query / first
     * @returns all sequences in this alignment
     */
  }, {
    key: "getQuerySequence",
    value: function getQuerySequence() {
      return this.querySequence;
    }
  }], [{
    key: "normalizeLetterCounts",
    value: function normalizeLetterCounts(letterCounts, validLetters) {
      var totalCounts = Object.keys(letterCounts).reduce(function (acc, letter) {
        if (!validLetters || validLetters.includes(letter)) {
          acc += letterCounts[letter];
        }
        return acc;
      }, 0);
      return Object.keys(letterCounts).reduce(function (acc, letter) {
        if (!validLetters || validLetters.includes(letter)) {
          acc[letter] = letterCounts[letter] / totalCounts;
        }
        return acc;
      }, {});
    }
  }]);
  return Alignment;
}();
exports.Alignment = Alignment;